import axios from '../../axios/axios';
import ipAddress from '../../axios/ipAddress' //域名
import QS from 'qs'; //序列化

/**
 * 优惠券类别
 */
const member = {

    /**
     * 优惠券
     */

     //优惠券列表
     memberList(){
        return axios.post(ipAddress.qi+'/admin/a1/vip-coupon/list',{},false)
    },

    //添加优惠券
    addMember(form){
        return axios.post(ipAddress.qi+'/admin/a1/vip-coupon/save',form,true)
    },

    //删除优惠券
    deleteMenber(id){
        return axios.post(ipAddress.qi+'/admin/a1/vip-coupon/delete',QS.stringify({
            id:id
        }),false)
    },


    /**
     * 发放优惠券
     */
    
    //搜索用户
    //添加优惠券
    memberUser(form){
        return axios.post(ipAddress.qi+'/admin/a1/user/query',form,true)
    },

    //发放优惠价
    sendMember(form){
        return axios.post(ipAddress.qi+'/admin/a1/user-coupon-xref/save',form,true)
    },

    //查询用户卷
    searchUser(id){
        return axios.post(ipAddress.qi+'/admin/a1/user-coupon-xref/getByUid',QS.stringify({
            uid:id
        }),false)
    },


}
export default member;


// WEBPACK FOOTER //
// ./src/js/member/member.js